export default {"src":"/_next/static/media/private-cloud-white.1f6268c3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};